const xmlToJson = (xml) => {
  // Polyfill Array
  if (!Array.isArray) {
    Array.isArray = function (arg) {
      return Object.prototype.toString.call(arg) === "[object Array]";
    };
  }

  let obj = {};

  if (xml.nodeType == 1) { // element
    // do attributes
    if (xml.attributes.length > 0) {
      obj["@attributes"] = {};
      for (var j = 0; j < xml.attributes.length; j++) {
        var attribute = xml.attributes.item(j);
        obj["@attributes"][attribute.nodeName] = attribute.nodeValue;
      }
    }
  } else if (xml.nodeType === 3 && !/^\s+$/.test(xml.nodeValue)) {
    // text
    obj = xml.nodeValue.trim();
  }

  // do children
  if (xml.hasChildNodes()) {
    if (xml.childNodes.length === 1 && xml.firstChild.nodeType === 3) {

      obj = xml.firstChild.nodeValue;
    } else {
      xml.childNodes.forEach(item => {
        const child = xmlToJson(item);
        if (child) {
          const nodeName = item.nodeName;
          if (!obj[nodeName]) {
            obj[nodeName] = xmlToJson(item);
          } else {
            if (!Array.isArray(obj[nodeName])) {
              obj[nodeName] = [obj[nodeName]];
            }
            obj[nodeName].push(xmlToJson(item));
          }
        }
      });
    }
  }

  return Object.keys(obj).length ? obj : undefined;
}

export const parseXML = text => {
  let parser;
  if (typeof window.DOMParser != "undefined") {
    parser = xmlStr =>
      new window.DOMParser().parseFromString(xmlStr, "text/xml");
  } else if (
    typeof window.ActiveXObject != "undefined" &&
    new window.ActiveXObject("Microsoft.XMLDOM")
  ) {
    parser = xmlStr => {
      var xmlDoc = new window.ActiveXObject("Microsoft.XMLDOM");
      xmlDoc.async = "false";
      xmlDoc.loadXML(xmlStr);
      return xmlDoc;
    };
  } else {
    throw new Error("No XML parser found");
  }

  return xmlToJson(parser(text));
};

export default parseXML;